/*!
 * vue-route-installer v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
function routeInstaller(View, Installer, Vue) {
  return function () {
    return Promise.all([View(), Installer()]).then(function (result) {
      var ViewComponent = result[0];
      var installer = result[1];
      Vue.use(installer.default || installer.install || installer);
      return ViewComponent;
    });
  };
}

export default routeInstaller;
